<template>
  <!-- footer -->
  <van-tabbar route :active-color="returnFColor()" class="newFoot">
    <van-tabbar-item replace to="/" icon="home-o"> 首页 </van-tabbar-item>
    <van-tabbar-item replace to="/bulletin" icon="warn-o">
      公告
    </van-tabbar-item>
    <van-tabbar-item
      replace
      to="/ordersP"
      icon="gold-coin-o"
      v-if="selfData.can_payment"
    >
      {{ $returnBuySel("进货") }}
    </van-tabbar-item>
    <van-tabbar-item
      replace
      to="/ordersAlp"
      v-if="selfData.can_payment && returnDomain()"
      icon="gold-coin-o"
    >
      支付宝
    </van-tabbar-item>
    <van-tabbar-item replace to="/ordersC" icon="cash-back-record">
      {{ $returnBuySel("出货") }}
    </van-tabbar-item>
    <van-tabbar-item
      :badge="$store.state.message.newMessagesCount || ''"
      replace
      icon="comment-circle-o"
      @click="$store.dispatch('message/showMessageBox', true)"
    >
      客服
    </van-tabbar-item>
    <van-tabbar-item replace to="/selfData" icon="friends-o">
      个人
    </van-tabbar-item>
  </van-tabbar>
  <!-- footer -->
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      isF: false,
    };
  },
  computed: {
    ...mapState(["selfData"]),
  },
  methods: {
    returnFColor() {
      if (document.domain == "store.olzde8213.com") {
        return "#A12412";
      }
      if (document.domain == "47.239.88.174") {
        return "#A12412";
      }
      if (document.domain == "47.239.169.10") {
        return "#A12412";
      }
      return "#009aaa";
    },
    returnDomain() {
      if (this.selfData.m_id == 60007) {
        return true;
      } else {
        return false;
      }
      // if (
      //   document.domain == "runn-f.test" ||
      //   document.domain == "store.rkzx921.com" ||
      //   document.domain == "119.91.195.29"
      // ) {
      //   return true;
      // } else {
      //   return false;
      // }
    },
  },

  created() {},
};
</script>

<style lang="scss" scoped>
.ttxx .newFoot {
  bottom: 50px;
  right: 10px;
  margin: 0 10px;
  left: 10px;
  width: 90%;
  border-radius: 50px;
  overflow: hidden;
  height: 65px;
  box-shadow: 1px solid gray;
}
</style>
